import { useState as u, useCallback as s, useEffect as o, useRef as f, useLayoutEffect as a } from "react";
import { BREAKPOINTS as d } from "./libServer.js";
import { EVENTS_HE as g, LOCALIZED_DOMAINS as z, MODULES_HE as H, addDaysToDate as B, calculateDaysDifference as I, debounce as O, dispatchEvent as k, formatDateToLocale as A, getHeaders as C, getServerHeaders as M, isBrowser as V, parseCookies as W } from "./libServer.js";
function D(t) {
  const [e, n] = u(!!t), i = s(() => n(!0), []), r = s(() => n(!1), []), c = s(() => n((w) => !w), []);
  return { value: e, setValue: n, setTrue: i, setFalse: r, toggle: c };
}
function T(t, e = 500) {
  const [n, i] = u(t);
  return o(() => {
    const r = setTimeout(() => i(t), e);
    return () => {
      clearTimeout(r);
    };
  }, [t, e]), n;
}
function E() {
  const [t, e] = u({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return o(() => {
    function n() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), t;
}
const m = typeof window < "u" ? a : o;
function L(t, e) {
  const n = f(t);
  m(() => {
    n.current = t;
  }, [t]), o(() => {
    if (!e && e !== 0)
      return;
    const i = setTimeout(() => {
      n.current();
    }, e);
    return () => {
      clearTimeout(i);
    };
  }, [e]);
}
function p() {
  const { width: t } = E();
  let e = "desktop";
  return t && t <= d.MOBILE ? e = "mobile" : t && t <= d.TABLET && (e = "tablet"), {
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop"
  };
}
function v(t, e, n) {
  o(() => {
    if (window)
      return window.addEventListener(t, e, n), () => {
        window.removeEventListener(t, e, n);
      };
  }, [t, e, n]);
}
export {
  d as BREAKPOINTS,
  g as EVENTS_HE,
  z as LOCALIZED_DOMAINS,
  H as MODULES_HE,
  B as addDaysToDate,
  I as calculateDaysDifference,
  O as debounce,
  k as dispatchEvent,
  A as formatDateToLocale,
  C as getHeaders,
  M as getServerHeaders,
  V as isBrowser,
  W as parseCookies,
  D as useBoolean,
  T as useDebounce,
  p as useDevice,
  v as useEvent,
  L as useTimeout,
  E as useWindowSize
};
